export type { AgeVerificationContentProps } from "./AgeVerificationContent";
export { AgeVerificationContent } from "./AgeVerificationContent";
